import { useEffect } from 'react'

type VideoModalProps = {
	isOpen: boolean
	close: () => void
	videoPlatform: 'youtube' | 'vimeo'
	videoId: string
}
export default function VideoModal({ isOpen, close, videoPlatform, videoId }: VideoModalProps) {
	// Keyboard event listener to close video
	useEffect(() => {
		const closeModal = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				close()
			}
		}

		window.addEventListener('keydown', closeModal)

		return () => window.removeEventListener('keydown', closeModal)
	}, [close])

	return isOpen ? (
		<div className="fixed inset-0 z-50 flex items-center bg-bbx-style/50 backdrop-blur">
			<div className="container flex justify-center">
				<div className="relative w-full max-w-screen-md shrink-0">
					{/* Close button */}
					<button type="button" className="absolute right-0 px-2 py-1 -top-10" onClick={close}>
						<i className="text-2xl text-white fa-light fa-xmark" />
					</button>

					<iframe
						title="Birchbox video"
						src={
							videoPlatform === 'youtube'
								? `https://www.youtube.com/embed/${videoId}?autoplay=1`
								: `https://player.vimeo.com/video/${videoId}?autoplay=1`
						}
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
						className="w-full aspect-video"
					/>
				</div>
			</div>
		</div>
	) : null
}
